<footer>
  <div class="footercopy">
    <div class="container">
      <p>© Copyright {{year}} - <a href="#">ALEC Engineering and Contracting </a>
        <!-- <a href="#">ALEC Central</a> <a href="#">Email Login</a> -->
      </p>
    </div>
  </div>
</footer>